import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, Popover2, Tooltip2, Fragment} from '@api'
import {Button, Menu, MenuDivider} from '@blueprintjs/core'
import {Tab} from '@material-ui/icons'
import {CatalogTabMenuItems, ContextMenuItem, OtherNewFlexTabMenuItems, useVipLocalStore, VipLocalStore, WorkspaceChooserMenuItems} from '@modules'
import {icons, StoresInstance} from '@stores'
import {FlexLayoutCatalogTabDropdownMenu, FlexLayoutUndoRedoToolbar, VipFlexLayoutTabStoreContext} from '@stores/catalog/flexLayout'
import * as css from './ActiveTabMenuDropdown.css'

/// region Store

export class ActiveTabMenuDropdownStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @observable foo = false

  @computed get bar() { return null }

  @action verb = () => {}
}

export const ActiveTabMenuDropdownStoreContext = React.createContext<ActiveTabMenuDropdownStore>(null)
export const useActiveTabMenuDropdownStore = () => React.useContext(ActiveTabMenuDropdownStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const ActiveTabMenuDropdown = observer<MyProps>(function ActiveTabMenuDropdown({className, ...props}) {
  const obsProps = useAsObservableSource({props}),
    store = useVipLocalStore((stores) => new ActiveTabMenuDropdownStore(stores, obsProps)),
    {flexLayout: {activeTab, create: {onNewWorkspaceItem}}} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <ActiveTabMenuDropdownStoreContext.Provider value={store}>
      <Popover2
        className={classNames(css.root, className)}
        interactionKind='hover'
        position='bottom-left'
        minimal
        content={
          <VipFlexLayoutTabStoreContext.Provider value={activeTab?.vipTabStore}>
            <Menu>
              <MenuDivider/>
              <ContextMenuItem text='New Report Item' icon='menu-open'>
                <WorkspaceChooserMenuItems onClickWorkspaceItem={onNewWorkspaceItem}/>
                <OtherNewFlexTabMenuItems/>
              </ContextMenuItem>
              <MenuDivider/>
              <CatalogTabMenuItems/>
            </Menu>
          </VipFlexLayoutTabStoreContext.Provider>
        }>
        <Button
          minimal
          icon={<Tab/>}
          text={`${activeTab?.displayName ?? 'New Tab'}${activeTab?.component === 'catalog' ? ` (${activeTab.catalogRoot?.catalog?.itemCount ?? '...'})` : ''}`}
          rightIcon='caret-down'/>
      </Popover2>

    </ActiveTabMenuDropdownStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/flexLayout-widgets/ActiveTabMenuDropdown.tsx